import { lerpColor } from '../../color';
import { hsl, type World } from '../../world';
import { dress, fx } from './dress';
import { paint } from './paint';
import './world.css';

const H = 10;
const S = 36;
const A1 = 45;
const A2 = 275;

const L = hsl(H, 72, 82);
const GOLD = hsl(A1, 88, 78);
const VIOLET = hsl(A2, 85, 76);
const RIM = hsl(H, 45, 92);

const world: World = {
  id: 'maracatu',
  name: 'Maracatu',
  seed: 'maracatu',
  legacy: false,
  hue: H,
  ceil: hsl(H, 0.8 * S, 28),
  font: 'Kavoon',
  fontFile: 'kavoon-400.woff2',
  fontWeight: '400',
  fontLicense: 'OFL-1.1',
  dark: true,
  boil: false,
  glow: 'add',
  glowAlpha: 0.4,
  fillAlpha: 0.7,
  palette: {
    bg: hsl(H, S, 10),
    ink: hsl(H, S + 12, 5),
    rim: RIM,
    held: GOLD,
    heldShade: hsl(A1, 60, 60),
    heldLight: hsl(A1, 90, 90),
    incoming: { circle: L, square: VIOLET, triangle: lerpColor(L, GOLD, 0.5), hex: lerpColor(L, VIOLET, 0.5) },
    spot: VIOLET,
    path: hsl(H, 30, 72),
    text: hsl(H, 40, 94),
    sparks: [GOLD, VIOLET, L, RIM],
  },
  burst: { count: 12, speed: 0.6, drag: 3, gravity: 0.5, spin: 6, life: 1, sizeMin: 0.009, sizeMax: 0.02 },
  dress,
  fx,
  paint,
};

export default world;
